import { Box } from '@chakra-ui/react';
import React from 'react';

function CommunityBarActions() {
  return <Box display='flex' gap={4} alignItems='center'></Box>;
}

export default CommunityBarActions;
